/**
 * A rule, or a measured gap.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readNumber, readString } from '@/domain/json'
import { type DividerSection } from '@/domain/section'
import DividerBlock from '@/sections/divider/DividerBlock.vue'
import DividerInspector from '@/sections/divider/DividerInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const dividerSection: SectionDefinition<'divider', DividerSection> = {
  kind: 'divider',
  band: 'structure',

  icon: ['M2.5 8h11', 'M4.5 4.5h7', 'M4.5 11.5h7'],

  create: (id, title) => ({
    id,
    kind: 'divider',
    title,
    variant: 'rule',
    space: 10,
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'divider',
    title,
    variant: readString(stored, 'variant') === 'space' ? 'space' : 'rule',
    space: readNumber(stored, 'space', 10),
  }),

  block: DividerBlock,
  inspector: DividerInspector,
}
